
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';
import ProfileBanner from '@/components/Account/ProfileBanner.vue';
import PageTitle from '@/components/PageTitle.vue';
import * as UserService from '@/services/userSpace/UserService';
import { isApplicationType } from '@/services/merchantSpace/PlatformService';
import { User } from '@/services/userSpace/types';
import { PlatformKey } from '@/constants';
import { Service, UserServiceProduct } from '@/services/merchantSpace/types';
import { getPlatformServices } from '@/api/resources/platformApi';
import { getCashbackTransactions, Transaction } from '@/api/resources/orderApi';
import { getUIConfig } from '@/configs';
import { getTranslation } from '@/i18n';

@Component({
  components: {
    ProfileBanner,
    PageTitle,
  },
})
export default class Profile extends Vue {
  user: User = {
    id: -1,
    email: '',
    password: '',
    externalAccountId: '',
    firstname: '',
    lastname: '',
    userServices: [],
  };

  platformServices: Service[] = [];

  userServicesWithProduct: Array<{ service: Service; actualProduct: UserServiceProduct }> = [];

  transactions: Transaction[] = [];

  async mounted() {
    this.user = await UserService.getCurrentUser();
    this.platformServices = await getPlatformServices();
    this.userServicesWithProduct = await UserService.getUserServices();
    this.transactions = await getCashbackTransactions(`${config.platformUuid}_${this.user.id}`);
  }

  get platform() {
    return this.$store.getters['platform/getPlatform'];
  }

  get userServices() {
    return this.userServicesWithProduct.map((el) => el.service);
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get compShowCashback() {
    return this.$store.getters['platform/getPlatform'].cashbackOffers;
  }

  get compIsThereTransactions() {
    return this.transactions.length > 0;
  }

  get isReadOnly() {
    return this.$store.getters['user/isReadOnly'];
  }

  get isSSOEnabled() {
    return this.$store.getters['platform/isSSOEnabled'];
  }

  get showPasswordLink() {
    return !this.isReadOnly && !this.isSSOEnabled;
  }

  get hasDeactivateLink(): boolean {
    return getUIConfig(this.platform.key, 'account.deactivateLink');
  }

  get hasDeleteLink(): boolean {
    return getUIConfig(this.platform.key, 'account.deleteLink');
  }

  navigateToPassword() {
    this.$router.push({ name: 'update-password' });
  }

  navigateToHelp() {
    this.$router.push({ name: 'help' });
  }

  navigateToOrders(): void {
    this.$router.push({ name: 'orders' });
  }

  navigateToDeactivate(): void {
    window.location.href = getTranslation(`${this.platform.key}.externalLink.deactivate`);
  }

  navigateToDelete(): void {
    window.location.href = getTranslation(`${this.platform.key}.externalLink.delete`);
  }

  navigateToCashback(): void {
    this.$router.push({ name: 'cashback' });
  }

  navigateToDocumentation(): void {
    this.$router.push({ name: 'documentation' });
  }

  navigateToPointsHistory() {
    this.$router.push({ name: 'history' });
  }

  navigateToPointsScale() {
    this.$router.push({ name: 'scale-points-public' });
  }
}
